var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRotateBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#307FC1",
    strokeWidth: 1.1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.28 8.61c.121-.379.273-.748.452-1.103M.963 11.978A7.797 7.797 0 0 1 .94 10.26M2.107 15.17a7.794 7.794 0 0 1-.73-1.481M4.51 17.586a7.821 7.821 0 0 1-1.305-1.04M7.817 18.754a7.776 7.776 0 0 1-1.654-.374M6.968 3.165H8.7a7.821 7.821 0 0 1 .862 15.59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 1 6.968 3.165 10 5.331"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateBack);
export default __webpack_public_path__ + "static/media/rotate-back.a06b0f2d35fd22f2ab0e35874c67d1ff.svg";
export { ForwardRef as ReactComponent };